/*
 * @Author: Hyman Choi
 * @Date: 2021-01-08 16:10:09
 * @LastEditTime: 2022-02-25 11:56:05
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Siui.Cloud.Medical.Web\src\router\Modules\system.js
 */
import Layout from "@/layout";
import {
    getRoleProd,
    getRoleAbroad
} from "@/router/roleHandler"
import config from "@/utils/config"

const systemRouter = {
    path: "/cloud_system_page",
    component: Layout,
    redirect: "/cloud_system_page/user_page",
    name: "systemManagement",
    meta: {
        roles: ["超级管理员", '系统管理员', 'Super Admin'],
        title: "systemManagement",
        icon: "systemManagement",
    },
    children: [{
        path: "user_page",
        name: "user_page",
        component: () => import("@/views/systemManagement/userManagement/index"),
        meta: {
            roles: ["超级管理员", '系统管理员', 'Super Admin'],
            title: "userManagement",
        },
    },
        {
            path: "userDetail",
            name: "userDetail",
            parent: ["user_page"],
            component: () =>
                import("@/views/systemManagement/userManagement/userDetail/index"),
            meta: {
                roles: ["超级管理员", '系统管理员', 'Super Admin'],
                title: "userDetail",
            },
            hidden: true,
        },
        {
            path: "role_page",
            name: "role_page",
            component: () => import("@/views/systemManagement/role-management/index"),
            meta: {
                roles: ["超级管理员", '系统管理员', 'Super Admin'],
                title: "RoleManagement",
            },
        },
        {
            path: "permission_page",
            name: "permission_page",
            component: () => import("@/views/systemManagement/permission-list/index"),
            meta: {
                roles: ["超级管理员", '系统管理员', 'Super Admin'],
                title: "PermissionList",
            },
        },
        {
            path: "user_verify_page",
            name: "user_verify_page",
            component: () =>
                import("@/views/systemManagement/userManagement/UserAuthentication/userCertificationView"),
            meta: {
                roles: ["超级管理员",
                    getRoleProd(config.SHOW_CERTIFICATION_MANAGEMENT),
                    getRoleAbroad(config.SHOW_CERTIFICATION_MANAGEMENT)
                ],
                title: "用户证件认证",
            },
        },
        {
            path: "version_page",
            name: "version_page",
            component: () =>
                import("@/views/systemManagement/AppVersion/index"),
            meta: {
                roles: ["超级管理员", '系统管理员', 'Super Admin'],
                title: "版本管理",
            },
        },
        {
            path: "publicVersion",
            name: "publicVersion",
            parent: ["version_page"],
            component: () =>
                import("@/views/systemManagement/AppVersion/appversion"),
            meta: {
                roles: ["超级管理员", '系统管理员', 'Super Admin'],
                title: "发布新版本",
            },
            hidden: true,
        },
        {
            path: "credit_rule_page",
            name: "credit_rule_page",
            component: () =>
                import("@/views/systemManagement/CreditRule/index"),
            meta: {
                roles: ["超级管理员",
                    getRoleProd(config.SHOW_CREDIT_RULES),
                    getRoleAbroad(config.SHOW_CREDIT_RULES)
                ],
                title: "积分规则",
            },
        },
        {
            path: "live_page",
            name: "live_page",
            component: () => import("@/views/systemManagement/liveMgt/index"),
            meta: {
                roles: ["超级管理员", '系统管理员', 'Super Admin'],
                title: "liveManagement",
            },
            children: [{
                path: "live_list_page",
                name: "live_list_page",
                component: () =>
                    import("@/views/systemManagement/liveMgt/liveList/index"),
                meta: {
                    roles: ["超级管理员", '系统管理员', 'Super Admin'],
                    title: "liveList",
                },
            },
                {
                    path: "live_config_page",
                    name: "live_config_page",
                    component: () =>
                        import("@/views/systemManagement/liveMgt/liveConfiguration/index"),
                    meta: {
                        roles: ["超级管理员", '系统管理员', 'Super Admin'],
                        title: "liveConfiguration",
                    },
                },
                {
                    path: "live_advertising_page",
                    name: "live_advertising_page",
                    component: () =>
                        import("@/views/systemManagement/liveMgt/adManagement/index"),
                    meta: {
                        roles: ["超级管理员", '系统管理员', 'Super Admin'],
                        title: "ADManagement",
                    },
                },
            ],
        },
        {
            path: "liveInfo",
            name: "liveInfo",
            parent: ["live_list_page"],
            component: () =>
                import("@/views/systemManagement/liveMgt/liveList/info/liveInfo"),
            meta: {
                roles: ["超级管理员", '系统管理员', 'Super Admin'],
                title: "直播信息",
            },
            hidden: true,
        },
        {
            path: 'notificationManagement',
            name: 'notificationManagement',
            parent: ["live_list_page"],
            component: () => import('@/views/systemManagement/liveMgt/liveList/notificationManagement'),
            meta: {
                roles: ["超级管理员", '系统管理员', 'Super Admin'],
                title: "通知管理",
            },
            hidden: true
        },
        {
            path: "liveUserDistribution",
            name: "liveUserDistribution",
            parent: ["live_list_page"],
            component: () =>
                import("@/views/systemManagement/liveMgt/liveList/LiveUserDistribution"),
            meta: {
                roles: ["超级管理员", '系统管理员', 'Super Admin'],
                title: "用户分布",
            },
            hidden: true,
        },
        {
            path: "liveRecorder",
            name: "liveRecorder",
            parent: ["live_list_page"],
            component: () =>
                import("@/views/systemManagement/liveMgt/liveList/liveRecorder"),
            meta: {
                roles: ["超级管理员", '系统管理员', 'Super Admin'],
                title: "直播录制",
            },
            hidden: true,
        },
        {
            path: "liveRegistration",
            name: "liveRegistration",
            parent: ["live_list_page"],
            component: () =>
                import("@/views/systemManagement/liveMgt/liveList/liveRegistration"),
            meta: {
                title: "直播登记信息",
            },
            hidden: true,
        },
        {
            path: "liveSignMsg",
            name: "liveSignMsg",
            parent: ["live_list_page"],
            component: () =>
                import("@/views/systemManagement/liveMgt/liveList/SignMsg/index"),
            meta: {
                title: "直播签到信息",
            },
            hidden: true,
        },
        {
            path: "liveSignUser",
            name: "liveSignUser",
            parent: ["live_list_page"],
            component: () =>
                import("@/views/systemManagement/liveMgt/liveList/SignMsg/SignUserList"),
            meta: {
                title: "直播签到用户信息",
            },
            hidden: true,
        },
        {
            path: "cs_document_page",
            name: "cs_document_page",
            component: () =>
                import("@/views/systemManagement/CSDocumentManagement/index.vue"),
            meta: {
                roles: ["超级管理员", '系统管理员', 'Super Admin'],
                title: "CSDocumentManagement",
            },
            children: [{
                path: "file",
                name: "file",
                parent: ['cs_document_page'],
                component: () =>
                    import(
                        "@/views/systemManagement/CSDocumentManagement/file/index.vue"
                        ),
                meta: {
                    roles: ["超级管理员", '系统管理员', 'Super Admin'],
                    title: "file",
                },
            },
                {
                    path: "resourceApply",
                    name: "resourceApply",
                    parent: ['cs_document_page'],
                    component: () =>
                        import("@/views/systemManagement/CSDocumentManagement/resourceApply/index"),
                    meta: {
                        roles: ["超级管理员", '系统管理员', 'Super Admin'],
                        title: "resourceApply",
                    },
                },
                {
                    path: "accessConfig",
                    name: "accessConfig",
                    parent: ['cs_document_page'],
                    component: () =>
                        import("@/views/systemManagement/CSDocumentManagement/accessConfig/index"),
                    meta: {
                        roles: ["超级管理员", '系统管理员', 'Super Admin'],
                        title: "accessConfig",
                    },
                },
                {
                    path: "categoryDetail/:id",
                    name: "categoryDetail",
                    component: () =>
                        import("@/components/FileManagement/File/CategoryDetail.vue"),
                    meta: {
                        roles: ["超级管理员", '系统管理员', 'Super Admin'],
                        title: "CategoryDetail",
                    },
                    hidden: true,
                    props: true,
                },
                {
                    path: "conditionDetail/:id",
                    name: "conditionDetail",
                    parent: ['cs_document_page'],
                    component: () =>
                        import("@/components/FileManagement/File/ConditionDetail.vue"),
                    meta: {
                        roles: ["超级管理员", '系统管理员', 'Super Admin'],
                        title: "ConditionDetail",
                    },
                    hidden: true,
                    props: true,
                },
            ],
        },
        {
            path: "device_manager_page",
            name: "device_manager_page",
            component: () =>
                import(
                    "@/views/systemManagement/instrumentManagement/index"
                    ),
            meta: {
                roles: ["超级管理员", '系统管理员', 'Super Admin'],
                title: "instrumentManagement",
            },
        },
        {
            path: "adminQuestionDetail",
            name: "adminQuestionDetail",
            parent: ['device_manager_page'],
            component: () =>
                import(
                    "@/components/FileManagement/Instrument/AdminQuestionDetail"
                    ),
            meta: {
                title: "问题详情",
            },
            hidden: true,
        },
        {
            path: "diagnosisManagement",
            name: "diagnosisManagement",
            component: () =>
                import("@/views/systemManagement/diagnosisManagement/index"),
            meta: {
                roles: ["超级管理员",
                    getRoleProd(config.SHOW_DIAGNOSIS_MANAGEMENT),
                    getRoleAbroad(config.SHOW_DIAGNOSIS_MANAGEMENT)
                ],
                title: "diagnosisManagement",
            },
            children: [{
                path: "roleApplicationManagement",
                name: "roleApplicationManagement",
                component: () =>
                    import(
                        "@/views/systemManagement/diagnosisManagement/roleApplicationMgt/index"
                        ),
                meta: {
                    roles: ["超级管理员",
                        getRoleProd(config.SHOW_DIAGNOSIS_MANAGEMENT),
                        getRoleAbroad(config.SHOW_DIAGNOSIS_MANAGEMENT)
                    ],
                    title: "roleApplicationManagement",
                },
            },
                {
                    path: "roleUserManagement",
                    name: "roleUserManagement",
                    component: () =>
                        import(
                            "@/views/systemManagement/diagnosisManagement/roleUserMgt/index"
                            ),
                    meta: {
                        roles: ["超级管理员",
                            getRoleProd(config.SHOW_DIAGNOSIS_MANAGEMENT),
                            getRoleAbroad(config.SHOW_DIAGNOSIS_MANAGEMENT)
                        ],
                        title: "roleUserManagement",
                    },
                },
                {
                    path: "teamManagement",
                    name: "teamManagement",
                    component: () =>
                        import(
                            "@/views/systemManagement/diagnosisManagement/teamMgt/index"
                            ),
                    meta: {
                        roles: ["超级管理员",
                            getRoleProd(config.SHOW_DIAGNOSIS_MANAGEMENT),
                            getRoleAbroad(config.SHOW_DIAGNOSIS_MANAGEMENT)
                        ],
                        title: "teamManagement",
                    },
                },
            ],
        },
        {
            path: "diagnosticUserDetail",
            name: "diagnosticUserDetail",
            component: () =>
                import(
                    "@/views/systemManagement/diagnosisManagement/roleApplicationMgt/detail/index"
                    ),
            meta: {
                roles: ["超级管理员",
                    getRoleProd(config.SHOW_DIAGNOSIS_MANAGEMENT),
                    getRoleAbroad(config.SHOW_DIAGNOSIS_MANAGEMENT)
                ],
                title: "diagnosticUserDetail",
            },
            hidden: true,
        },
        {
            path: "diagnosticTeamDetail",
            name: "diagnosticTeamDetail",
            component: () =>
                import(
                    "@/views/systemManagement/diagnosisManagement/teamMgt/detail/index"
                    ),
            meta: {
                roles: ["超级管理员",
                    getRoleProd(config.SHOW_DIAGNOSIS_MANAGEMENT),
                    getRoleAbroad(config.SHOW_DIAGNOSIS_MANAGEMENT)
                ],
                title: "diagnosticTeamDetail",
            },
            hidden: true,
        },
        {
            path: "diagnosticTeamMember",
            name: "diagnosticTeamMember",
            component: () =>
                import(
                    "@/views/systemManagement/diagnosisManagement/teamMgt/member/index"
                    ),
            meta: {
                roles: ["超级管理员",
                    getRoleProd(config.SHOW_DIAGNOSIS_MANAGEMENT),
                    getRoleAbroad(config.SHOW_DIAGNOSIS_MANAGEMENT)
                ],
                title: "diagnosticTeamMember",
            },
            hidden: true,
        },
        {
            path: "diagnosticJoinTeamReq",
            name: "diagnosticJoinTeamReq",
            component: () =>
                import(
                    "@/views/systemManagement/diagnosisManagement/teamMgt/request/index"
                    ),
            meta: {
                roles: ["超级管理员",
                    getRoleProd(config.SHOW_DIAGNOSIS_MANAGEMENT),
                    getRoleAbroad(config.SHOW_DIAGNOSIS_MANAGEMENT)
                ],
                title: "diagnosticJoinTeamReq",
            },
            hidden: true,
        },
        {
            path: "diagnosticJoinTeamDetail",
            name: "diagnosticJoinTeamDetail",
            component: () =>
                import(
                    "@/views/systemManagement/diagnosisManagement/teamMgt/request/reqDetail/index"
                    ),
            meta: {
                roles: ["超级管理员",
                    getRoleProd(config.SHOW_DIAGNOSIS_MANAGEMENT),
                    getRoleAbroad(config.SHOW_DIAGNOSIS_MANAGEMENT)
                ],
                title: "diagnosticJoinTeamDetail",
            },
            hidden: true,
        },
        {
            path: "problem_page",
            name: "problem_page",
            component: () => import("@/views/systemManagement/quizManagement/index"),
            meta: {
                roles: ["超级管理员",
                    getRoleProd(config.SHOW_QUIZ_MANAGEMENT),
                    getRoleAbroad(config.SHOW_QUIZ_MANAGEMENT)
                ],
                title: "quizManagement",
            },
        },
        {
            path: "quizDetail",
            name: "quizDetail",
            parent: ["problem_page"],
            component: () =>
                import("@/views/systemManagement/quizManagement/quizDetail/index"),
            meta: {
                roles: ["超级管理员",
                    getRoleProd(config.SHOW_QUIZ_MANAGEMENT),
                    getRoleAbroad(config.SHOW_QUIZ_MANAGEMENT)
                ],
                title: "quizDetail",
                activeMenu: "/cloud_system_page/problem_page",
            },
            hidden: true,
            props: true,
        },
        {
            path: "quizAnswerReply",
            name: "quizAnswerReply",
            parent: ["problem_page"],
            component: () =>
                import("@/views/systemManagement/quizManagement/quizDetail/answerReply"),
            meta: {
                roles: ["超级管理员",
                    getRoleProd(config.SHOW_QUIZ_MANAGEMENT),
                    getRoleAbroad(config.SHOW_QUIZ_MANAGEMENT)
                ],
                title: "答案评论",
                activeMenu: "/cloud_system_page/problem_page",
            },
            hidden: true,
            props: true,
        },
        {
            path: "couponManagement",
            name: "couponManagement",
            component: () =>
                import("@/views/systemManagement/couponManagement/index"),
            meta: {
                roles: ["超级管理员"],
                title: "couponManagement",
            },
        },
        {
            path: "slide_image_controller",
            name: "slide_image_controller",
            component: () =>
                import("@/views/systemManagement/carousel-management/index"),
            meta: {
                roles: ["超级管理员", '系统管理员', 'Super Admin'],
                title: "CarouselManagement",
            },
        },
        {
            path: "netDisk",
            name: "netDisk",
            component: () => import("@/views/systemManagement/netDisk/index"),
            meta: {
                roles: ["超级管理员",
                    getRoleProd(config.SHOW_QUIZ_MANAGEMENT)
                ],
                title: "netDiskManagement",
            },
        },
        {
            path: "appAdDetail",
            name: "appAdDetail",
            parent: ["slide_image_controller"],
            component: () =>
                import("@/components/CarouselManagement/AppAdDetail"),
            meta: {
                roles: ["超级管理员", '系统管理员', 'Super Admin'],
                title: "App广告轮播图详情",
            },
            hidden: true,
        },
        {
            path: "maiLiveSliderImageDetail",
            name: "maiLiveSliderImageDetail",
            parent: ["slide_image_controller"],
            component: () =>
                import("@/components/CarouselManagement/MaiLiveSliderImageDetail"),
            meta: {
                roles: ["超级管理员", '系统管理员', 'Super Admin'],
                title: "麦粒学院轮播图详情",
            },
            hidden: true,
        },
        {
            path: "forumGroupSliderImageDetail",
            name: "forumGroupSliderImageDetail",
            parent: ["slide_image_controller"],
            component: () =>
                import("@/components/CarouselManagement/ForumGroupSlideImageDetail"),
            meta: {
                roles: ["超级管理员", '系统管理员', 'Super Admin'],
                title: "超人圈轮播图详情",
            },
            hidden: true,
        },
        {
            path: "productSliderImageDetail",
            name: "productSliderImageDetail",
            parent: ["slide_image_controller"],
            component: () =>
                import("@/components/CarouselManagement/ProductSliderImageDetail"),
            meta: {
                title: "产品轮播图详情",
            },
            hidden: true,
        },
        {
            path: "column_page",
            name: "column_page",
            component: () =>
                import("@/views/systemManagement/module-management/index"),
            meta: {
                roles: ["超级管理员", '系统管理员', 'Super Admin'],
                title: "ModuleManagement",
            },
        },
        {
            path: "ModuleCustomization/:parentID",
            name: "ModuleCustomization",
            parent: ['column_page'],
            component: () =>
                import(
                    "@/views/systemManagement/module-management/module-customization/index"
                    ),
            meta: {
                roles: ["超级管理员", '系统管理员', 'Super Admin'],
                title: "ModuleCustomization",
            },
            hidden: true,
            props: true,
        },
        {
            path: "filterSetting",
            name: "filterSetting",
            parent: ['column_page'],
            component: () =>
                import(
                    "@/views/systemManagement/module-management/filterSetting/index"
                    ),
            meta: {
                roles: ["超级管理员", '系统管理员', 'Super Admin'],
                title: "filterSetting",
            },
            hidden: true,
            props: (route) => ({
                row: route.params.row
            }),
        },
        {
            path: "resourceManagement",
            name: "resourceManagement",
            component: () =>
                import("@/views/systemManagement/resourceManagement/index"),
            meta: {
                roles: ["超级管理员"],
                title: "resourceManagement",
            },
        },
        {
            path: "content_secure_page",
            name: "content_secure_page",
            component: () => import("@/views/systemManagement/contentSecurity/index"),
            meta: {
                roles: ["超级管理员", '系统管理员', 'Super Admin'],
                title: "contentSecurity",
            },
        },
        {
            path: "productionInfoManagement",
            name: "productionInfoManagement",
            component: () =>
                import("@/views/systemManagement/productionInfoManagement/index"),
            meta: {
                roles: ["超级管理员"],
                title: "productionInfoManagement",
            },
        },
        {
            path: "classificationManagement",
            name: "classificationManagement",
            component: () =>
                import(
                    "@/views/systemManagement/productionInfoManagement/classificationManagement"
                    ),
            meta: {
                roles: ["超级管理员", '系统管理员', 'Super Admin'],
                title: "classificationManagement",
            },
            hidden: true,
        },
        {
            path: "cloudResourceManagement",
            name: "cloudResourceManagement",
            component: () =>
                import("@/views/systemManagement/cloudResourceManagement/index"),
            meta: {
                roles: ["超级管理员"],
                title: "cloudResourceManagement",
            },
        },
        {
            path: "files",
            name: "files",
            component: () =>
                import(
                    "@/views/systemManagement/cloudResourceManagement/files/index.vue"
                    ),
            meta: {
                roles: ["超级管理员", "普通用户", '系统管理员', 'Super Admin', 'Common User'],
                title: "files",
            },
            hidden: true,
        },
        {
            path: "staffManagement",
            name: "staffManagement",
            component: () => import("@/views/systemManagement/staffManagement/index"),
            meta: {
                roles: ["超级管理员"],
                title: "staffManagement",
            },
        },
        {
            path: "feedback_page",
            name: "feedback_page",
            component: () => import("@/views/systemManagement/Feedback/index"),
            meta: {
                roles: ["超级管理员"],
                title: "反馈信息",
            },
        },
        {
            path: "userFeedbackDetail",
            name: "userFeedbackDetail",
            parent: ['feedback_page'],
            component: () =>
                import(
                    "@/views/systemManagement/Feedback/UserFeedbackDetail"
                    ),
            meta: {
                roles: ["超级管理员", '系统管理员', 'Super Admin'],
                title: "用户反馈详情",
            },
            hidden: true,
            props: true,
        },
        {
            path: "deviceFeedbackDetail",
            name: "deviceFeedbackDetail",
            parent: ['feedback_page'],
            component: () =>
                import(
                    "@/views/systemManagement/Feedback/DeviceFeedbackDetail"
                    ),
            meta: {
                roles: ["超级管理员", '系统管理员', 'Super Admin'],
                title: "设备反馈详情",
            },
            hidden: true,
            props: true,
        },
        {
            path: "app_report_page",
            name: "app_report_page",
            component: () =>
                import("@/views/systemManagement/AppReport/index"),
            meta: {
                roles: ["超级管理员", '系统管理员', 'Super Admin'],
                title: "举报投诉",
            },
        },
        {
            path: "menu_page",
            name: "menu_page",
            component: () =>
                import("@/views/systemManagement/roleMenuManager/index"),
            meta: {
                roles: ["超级管理员", '系统管理员', 'Super Admin'],
                title: "角色菜单管理",
            },
        },
    ],
};

export default systemRouter;
